/** @format */

import { CartItem } from '../cart/cart.model';
import { ShipModeInformation } from './edd.model';

export interface ShipModeGroup {
  // Element to hold Estimated Delivery Dates
  dates?: string[];
  group_name: string;
  group_name_display: string;
  group_number: number;

  // Element to hold selected shipping edd information
  information?: ShipModeInformation;

  isOpen?: boolean;

  items?: ShipModeGroupItem[];

  // Element to hold selected ship mode
  mode?: ShipMode;

  // Element to hold available ship modes
  modes?: ShipMode[];
}

export interface ShipModeGroupsType {
  external_source?: string;
  groups: ShipModeGroup[];
}

export interface ShipModeGroupItem extends CartItem {
  disableAnimations: boolean;
  reference_key?: string;
}

export interface ShipMode {
  description: string;
  external_key?: string;
  provider: string;
  ship_method?: string;
  unit_price: string;
}

export class ShipModeEddGroup {
  public groupNumber: number;
  public eddMap = new Map<string, ShipModeGroupItem[]>();

  constructor(args: Partial<ShipModeEddGroup>) {
    this.groupNumber = args.groupNumber;
  }
}
